module.exports = __webpack_public_path__ + "static/media/urban-farming-tablet.fb9aecfa.jpg";